import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from "@spartacus/storefront";
import { CmsService } from "@spartacus/core";
import { map, switchMap } from "rxjs/operators";
import { combineLatest, Observable } from "rxjs";
import { CustomHelpComponentData } from "./custom-help.model";
import { ICON_TYPE } from "../../../icons/icon.model";

@Component({
  selector: 'app-custom-help',
  templateUrl: './custom-help.component.html',
  styleUrls: ['./custom-help.component.scss'],
  standalone: false
})
export class CustomHelpComponent implements OnInit {

  cmsItemType = 'CMSItemComponent';

  iconTypes = ICON_TYPE;

  constructor(private componentData: CmsComponentData<CustomHelpComponentData>, private cmsService: CmsService) {}

  data$ = this.componentData.data$?.pipe(map(component => component));

  items$: Observable<any[]> = this.componentData.data$?.pipe(
    switchMap(data =>
      combineLatest(
        data.items?.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));

  ngOnInit(): void {
  }
}
